import { render } from "./ChatsView.vue?vue&type=template&id=7d692515&scoped=true"
import script from "./ChatsView.vue?vue&type=script&lang=js"
export * from "./ChatsView.vue?vue&type=script&lang=js"

import "./ChatsView.vue?vue&type=style&index=0&id=7d692515&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d692515"]])

export default __exports__